import { useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";

export default function ProfileCard() {
  const { user, setUser } = useAuth();
  const { t } = useLang();
  const nameParts = (user?.name || "").split(" ");
  const [form, setForm] = useState({
    first_name: user?.first_name || nameParts[0] || "",
    last_name: user?.last_name || nameParts.slice(1).join(" ") || "",
    billing_email: user?.billing_email || user?.email || "",
    phone: user?.phone || "",
  });
  const [saving, setSaving] = useState(false);

  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    setSaving(true);
    try {
      const res = await api.put("/profile", form);
      setUser(res.data);
      toast.success(t("profile.saved"));
    } catch (e) {
      toast.error(t("profile.error"));
    } finally {
      setSaving(false);
    }
  };

  const field = (key, type = "text") => (
    <div>
      <label className="text-xs text-slate-400 font-mono">{t(`profile.${key === "billing_email" ? "email" : key === "first_name" ? "firstName" : key === "last_name" ? "lastName" : "phone"}`)}</label>
      <input
        type={type}
        value={form[key]}
        onChange={upd(key)}
        data-testid={`profile-${key}`}
        className="mt-1.5 w-full rounded-xl bg-[#0e131c] border border-white/10 px-4 py-3 text-white text-sm focus:border-[#F5842B]/60 focus:outline-none transition-colors"
      />
    </div>
  );

  return (
    <div className="glass rounded-2xl p-7 mb-10" data-testid="profile-card">
      <h2 className="font-display text-2xl font-bold">{t("profile.title")}</h2>
      <p className="text-sm text-slate-400 mt-1">{t("profile.subtitle")}</p>
      <div className="grid sm:grid-cols-2 gap-4 mt-6">
        {field("first_name")}
        {field("last_name")}
        {field("billing_email", "email")}
        {field("phone", "tel")}
      </div>
      <button onClick={save} disabled={saving} className="mt-6 adj-gradient text-white font-semibold px-6 py-3 rounded-full flex items-center gap-2 hover:opacity-90 transition-opacity disabled:opacity-60" data-testid="profile-save-btn">
        {saving ? <Loader2 size={17} className="animate-spin" /> : <Save size={17} />} {t("profile.save")}
      </button>
    </div>
  );
}
